<template>
  <v-dialog v-model="dOpenComponent" persistent full-width>
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ dInformeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-dialog v-if="dOpenComponent" v-model="dLoading" hide-overlay persistent width="300">
        <v-card class="datModalTitleContainer" dark>
          <v-card-text>
            {{ $t('cargandoContenido') }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-form ref="form" lazy-dValidation>
        <v-layout v-if="cRoleUser === 'ADMIN' || cRoleUser === 'REPRESENTANTE'" row wrap justify-end>
        </v-layout>
        <v-card-text>
          <div class="subheading font-weight-bold mt-2 mb-2 px-3">{{ dInformeComponente.descripcion }}</div>
        </v-card-text>
        <v-layout row wrap>
          <v-flex xs12 ml-3 mr-3>
            <v-layout row wrap>
              <v-flex md12 px-2>
                <label>{{ this.$t("aplicarFiltrosYcomenzar") }}</label>
              </v-flex>
              <v-flex md12 px-2>
                <v-layout>
                  <v-flex md3 px-2>
                    <v-menu :ref="dDatosFiltros.fechaIniMenu" lazy v-model="dDatosFiltros.fechaIniMenu"
                      transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                      :close-on-content-click="false">
                      <v-text-field required clearable color="data-colorcorp1" slot="activator"
                        :label="$t('fechaInicial')" v-model="dDatosFiltros.fechaIniString" append-icon="event"
                        readonly></v-text-field>
                      <v-date-picker required :min="dDatosFiltros.fechaMinIni" clearable
                        v-model="dDatosFiltros.fechaIni" no-title scrollable :first-day-of-week="1" locale="es-es"
                        @input="fGetFecha(dDatosFiltros.fechaIni, 'ini')"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex md3 px-2>
                    <v-menu :ref="dDatosFiltros.fechaFinMenu" lazy v-model="dDatosFiltros.fechaFinMenu"
                      transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                      :close-on-content-click="false">
                      <v-text-field required clearable color="data-colorcorp1" slot="activator"
                        :label="$t('fechaFinal')" v-model="dDatosFiltros.fechaFinString" append-icon="event"
                        readonly></v-text-field>
                      <v-date-picker required :min="dDatosFiltros.fechaMinFin" clearable
                        v-model="dDatosFiltros.fechaFin" no-title scrollable :first-day-of-week="1" locale="es-es"
                        @input="fGetFecha(dDatosFiltros.fechaFin, 'fin')"></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout v-if="cRoleUser !== 'SUCURSAL'">
                  <v-flex v-if="cRoleUser !== 'CLIENTE' && cRoleUser !== 'MULTISUCURSAL'" md3 px-2>
                    <DatTextFieldCode ref="TextClient" :pDataPass="dDataClient" @select="fSelectClient"
                      @clean="fClearClient" @alert="fAlert"></DatTextFieldCode>
                  </v-flex>
                  <v-flex md3 px-2>
                    <DatTextFieldCode v-if="!dIsOnPremise" ref="TextSucursal" :pDataPass="dDataSucursal"
                      @select="fSelectSucursal" @clean="fClearSucursal" @alert="fAlert"></DatTextFieldCode>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>
            <v-layout v-if="(cRoleUser === 'ADMIN' || cRoleUser === 'REPRESENTANTE') && dFiltroActivo" row wrap>
              <v-flex md12 px-2>
                <label>{{ $t("advancedFilters") }}</label>
              </v-flex>
              <v-flex md6 px-2>
                <v-select clearable :items="dAgencias" item-value="id" item-text="text"
                  v-model="dDatosFiltros.agenciaTrans" @change="fSelect($event, 'agencia')"
                  :label="this.$t('agenciaTransporte')"></v-select>
              </v-flex>
            </v-layout>
            <v-flex xs12 text-xs-right>
              <v-btn @click="fPrepareTratamientos()" class="datSecondaryBtn" small flat tile>{{ $t('buscar') }}</v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-flex>
          <v-layout row wrap>
            <v-flex text-xs-center class="mb-3">
              <v-data-table item-key="rn" :loading="dLoading" single-expand :no-results-text="this.$t('noResultados')"
                :no-data-text="this.$t('noResultados')" :rows-per-page-text="$t('numCertifPagina')"
                v-bind:pagination.sync="dPaginationPED" :total-items="dTotalItems" class="tablePedidos"
                :rows-per-page-items="dRowsPerPageItemsPED" :items="dDatosTabla" :headers="dHeadersTable">
                <template slot="headers" slot-scope="props">
                  <tr class="lightPrimaryColorBackground">
                    <th class="text-xs-center" v-for="header in props.headers" :key="header.text" :id="header.value"
                      :class="['column sortable', dPaginationPED.descending ? 'desc' : 'asc', header.value === dPaginationPED.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']"
                      @click="fCambiaOrden(header.value)">
                      <v-icon v-if="header.sortable">arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="text-xs-center pr-0 pl-2" style="width:40px" @click="fGetDetTratamientos(props)">
                      <v-icon :class="props.expanded ? 'iconRotate cursorPointer' : 'cursorPointer'">
                        arrow_downward
                      </v-icon>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.NumContrato }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.FechaContrato }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.FechaVigencia }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.OperTraslado }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.TitularOrigen }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.TitularDestino }}</span>
                    </td>
                    <td class="text-xs-center ellipsis">
                      <span>{{ props.item.NotfPrevia }}</span>
                    </td>
                    <td class="text-xs-center">
                      <v-btn flat icon>
                        <v-icon @click="fDownloadReport(props.item)">mdi-file-pdf-box</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template slot="expand" slot-scope="props">

                  <thead class="lighterPrimaryColorBackground">
                    <tr class="px-2">
                      <th v-for="item in dHeadersSubTabla" :key="item.value" :id="item.value" :width="item.width"
                        :class="item.class">{{ item.text }}</th>
                    </tr>
                  </thead>
                  <tr v-for="item in dSubDatosTabla" :key="item.codigoLER" :class="props.expanded ? 'selectedRow' : ''">
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.codLER }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.denomLER }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.codTrat }}</span>
                    </td>
                    <td class="text-xs-center " style="vertical-align: middle">
                      <span>{{ item.descTrat }}</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import ServiceTratamientos from '@/services/srv-tratamientos'

import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'

export default {
  components: {
    DatTextFieldCode
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true,
      default: false
    },
    pLimitDate: {
      type: Object,
      required: true,
      default: false
    }
  },
  data() {
    return {
      dOpenComponent: true,
      dInformeComponente: {},
      dClassHeader: 'subHeaderTextInTable text-xs-center',
      dLimitDate: {},
      dRole: null,
      dFiltroActivo: false,
      dScreenWidth: screen.width,
      dDatosFiltros: {},
      dHeadersTable: [],
      dDatosTabla: [],
      dHeadersSubTabla: [],
      dSubDatosTabla: [],
      dFormatDate: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dRowsPerPageItemsPED: [5, 10, 25],
      dRowsPerPage: 10,
      dTotalItems: 0,
      dLoading: false,
      dPaginationPED: { 'sortBy': 'fechaContrato', 'descending': false, 'rowsPerPage': 10, 'page': 1 },
      dDataClient: {},
      dDataSucursal: {},
      dSelectCliente: {},
      dSelectSucursal: {},
      dIsOnPremise: localStorage.getItem('isOnPremise') === 'yes',
      dRequestCliente: { empresa: this.$store.getters.getAutenticacion.empresa }
    }
  },
  created() {
    this.fIniciarVariables()
    this.dRole = this.pLimitDate.roleUser
  },
  mounted() {
    this.dInformeComponente = this.pInformeComponente
    this.dLimitDate = this.pLimitDate
  },
  computed: {
    cRoleUser() {
      return this.dRole
    }
  },
  methods: {
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    fCerrarVentana() {
      this.$emit('close')
    },
    fLoading(msg) {
      this.$emit('loading', msg)
    },
    fIniciarVariables() {
      this.dInformeComponente = this.pInformeComponente

      // HEADERS TABLE
      this.dHeadersTable = [
        { text: '', align: 'left', value: '', sortable: false, class: 'px-0', width: '10px', fixed: true },
        { text: this.$t('numContr'), align: 'left', value: 'NumContrato', sortable: true, class: '' },
        { text: this.$t('fechaContr'), align: 'left', value: 'FechaContrato', sortable: true, class: '' },
        { text: this.$t('fechaVig'), align: 'left', value: 'FechaVigencia', sortable: true, class: '' },
        { text: this.$t('operTraslado'), align: 'left', value: 'OperTraslado', sortable: true, class: '' },
        { text: this.$t('titularOrigen'), align: 'left', value: 'TitularOrigen', sortable: true, class: '' },
        { text: this.$t('titularDestino'), align: 'left', value: 'TitularDestino', sortable: true, class: '' },
        { text: this.$t('notfPrevia'), align: 'left', value: 'NotfPrevia', sortable: true, class: '' },
        { text: this.$t('descarga'), value: this.$t('descarga'), sortable: false }
      ]

      // HEADERS SUBTABLE
      this.dHeadersSubTabla = [
        { text: this.$t('codLER'), align: 'left', value: 'CodLER', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('denomLer'), align: 'left', value: 'DenomLER', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('codTrat'), align: 'left', value: 'CodTrat', sortable: true, class: this.dClassHeader, width: '500px' },
        { text: this.$t('descTrat'), align: 'left', value: 'DescTrat', sortable: true, class: this.dClassHeader, width: '500px' }
      ]

      // VARIABLES DE LA STORE LOCAL
      this.dEmpresa = this.$store.getters.getAutenticacion.empresa
      this.dTira = this.$store.getters.getAutenticacion.tira
      this.dIdOrganizacion = this.$store.getters.getAutenticacion.organizacion

      // DATOS FILTROS
      this.dDatosFiltros = {
        empresa: this.dEmpresa,
        tira: this.dTira,
        fechaIni: '',
        fechaIniString: '',
        fechaIniMenu: null,
        fechaFin: '',
        fechaFinString: '',
        fechaFinMenu: null,
        cliente: null,
        sucursalClte: null
      }

      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',

        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestCliente,
        'default': this.dSelectCliente,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }

      this.dDataSucursal = {
        'errorMessages': [],
        'label': this.$t('sucursal'),
        'rowsPerPage': 10,
        'headers': [
          { text: this.$t('sucursal'), align: 'left', value: 'codigo', column: 'sucursal' },
          { text: this.$t('nombreSucursal'), align: 'left', value: 'nombre', column: 'razonSocial' }
        ],
        'urlWS': 'lovDic',

        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'sucursal', 'nombre': 'razonSocial' },
        'resultName': 'dataRes',
        'request': null,
        'default': this.dSelectSucursal,
        'disabled': true,
        'required': true,
        'orderByDefault': 'sucursal',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': this.$t('seleccionaUnaSucursal'),
        'client': this.dSelectCliente.codigo
      }
      if (this.pLimitDate.roleUser === 'CLIENTE' || this.pLimitDate.roleUser === 'MULTISUCURSAL') {
        this.dDataSucursal.disabled = false
        this.dDataSucursal.request = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: this.$store.getters.getAutenticacion.cliente
        }
      }
      this.fLimitFechas()
    },
    fGetFecha(val, tipo) {
      switch (tipo) {
        case 'ini':
          this.dDatosFiltros.fechaIniString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
          this.dDatosFiltros.fechaIniMenu = false
          break
        case 'fin':
          this.dDatosFiltros.fechaFinString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
          this.dDatosFiltros.fechaFinMenu = false
          break
      }
    },
    fLimitFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dDatosFiltros.fechaIni = this.pLimitDate.fechaIniLimit
        this.dDatosFiltros.fechaMinIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.years)
        this.dDatosFiltros.fechaIniString = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.default)
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dDatosFiltros.fechaFin = this.pLimitDate.fechaFinLimit
        this.dDatosFiltros.fechaMinFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.years)
        this.dDatosFiltros.fechaFinString = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    },
    fPrepareTratamientos() {
      if (this.dRole === 'CLIENTE') {
        this.dDatosFiltros.cliente = this.$store.getters.getAutenticacion.cliente
      }
      if (this.dRole === 'SUCURSAL') {
        this.dDatosFiltros.cliente = this.$store.getters.getAutenticacion.cliente
        this.dDatosFiltros.sucursalClte = JSON.parse(localStorage.getItem('datos-autenticacion')).sucursal
      }
      if (this.dRole === 'MULTISUCURSAL') {
        this.dDatosFiltros.cliente = this.$store.getters.getAutenticacion.cliente
      }
      if (this.fCheckFilters()) {
        this.dLoading = true
        this.dDatosTabla = [];
        // 
        const payload = {
          tira: this.dDatosFiltros.tira,
          empresa: this.dDatosFiltros.empresa,
          fechaIni: this.dDatosFiltros.fechaIniString,
          fechaFin: this.dDatosFiltros.fechaFinString,
          cliente: parseInt(this.dDatosFiltros.cliente),
          sucursalClte: parseInt(this.dDatosFiltros.sucursalClte),
          offset: this.dPaginationPED.rowsPerPage * (this.dPaginationPED.page - 1) + 1,
          numRows: this.dPaginationPED.rowsPerPage,
          orderBy: this.dPaginationPED.sortBy,
          order: (this.dPaginationPED.descending) ? 'DESC' : 'ASC'
        }
        // 
        ServiceTratamientos.getTratamientos(payload).then(response => {
          if (this.fRespuestaCorrecta(response)) {
            const datos = response.data.dataRes
            if (datos.length > 0) {
              datos.forEach(item => {
                this.dDatosTabla.push({
                  'rn': item.rn,
                  'OperTraslado': item.operTraslado,
                  'FechaVigencia': item.FechaVigencia,
                  'FechaContrato': this.$moment(item.fechaContrato, this.dFormatDate.years).format(this.dFormatDate.default),
                  'NumContrato': item.numContrato,
                  'TitularOrigen': item.titularOrigen,
                  'TitularDestino': item.titularDestino,
                  'NotfPrevia': item.notfPrevia
                })
                if (item.fechaContrato !== '' && item.fechaContrato !== undefined) {
                  this.dDatosTabla.FechaVigencia = this.$moment(item.fechaVigencia, this.dFormatDate.years).format(this.dFormatDate.default)
                }
              })
              this.dTotalItems = response.data.numReg
            }
          }
          this.dLoading = false
        })
      } else {
        this.$emit('alert', '<b>' + this.$t('filtersAlert') + '</b><br/>' + this.$t('filtersClient'))
      }
    },
    fGetDetTratamientos(props) {
      props.expanded = !props.expanded
      this.dSubDatosTabla = []
      if (props.expanded) {
        this.dLoading = true
      }
      const payload = {
        tira: this.dDatosFiltros.tira,
        empresa: this.dDatosFiltros.empresa,
        numContrato: props.item.NumContrato
      }
      ServiceTratamientos.getDetTratamientos(payload).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const datos = response.data.dataRes
          if (datos.length > 0) {
            datos.forEach(item => {
              this.dSubDatosTabla.push({
                'denomLER': item.denomLER,
                'descTrat': item.descTrat,
                'codTrat': item.codTrat,
                'codLER': item.codLER,
                'rn': item.rn
              })
            })
          }
        }
        this.dLoading = false
      })
    },
    fDownloadReport(contrato) {
      const payload = {
        numContrato: contrato.NumContrato,
        empresa: this.$store.getters.getAutenticacion.empresa
      }
      this.dLoading = true
      ServiceTratamientos.getImprimirContrat(payload).then(respuesta => {
        if (respuesta.data.statusCode === '200' && respuesta.data.numReg > 0) {
          window.open(respuesta.data.dataRes.url)
        } else {
          this.$emit('alert', '<b>' + this.$t('notFoundReport') + '</b><br/>' + this.$t('notFoundReportDesc'))
        }
        this.dLoading = false
      }).catch(error => {
        console.error(error)
        this.dLoading = false
        this.$emit('alert', '<b>' + this.$t('notFoundReport') + '</b><br/>' + this.$t('notFoundReportDesc'))
      })
    },
    fCheckFilters() {
      return (this.dDatosFiltros.cliente !== undefined && this.dDatosFiltros.cliente !== '' && this.dDatosFiltros.cliente !== null)
    },
    fSelectClient(item) {
      if (this.dDatosFiltros.cliente !== '' || this.dDatosFiltros.cliente !== undefined) {
        this.fClearClient()
      }
      this.dDatosFiltros.cliente = item.codigo
      if (item.codigo !== '' && item.codigo !== undefined) {
        this.$refs.TextSucursal.fChangeDisabled(false)
      }
      this.dDataSucursal.client = item.codigo
      this.dDataSucursal.request = {
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: item.codigo
      }
    },
    fClearClient() {
      this.$refs.TextSucursal.fChangeDisabled(true)
      this.fClearSucursal()

      this.$refs.TextSucursal.fClear()
      this.dSelectCliente = {}
    },
    fSelectSucursal(item) {
      this.dDatosFiltros.sucursalClte = item.codigo
    },
    fClearSucursal() {
      this.dDataSucursal.disabled = true
      this.dSelectSucursal = {}
    },
    fRespuestaCorrecta(response) {
      let returnValue = false
      if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
        returnValue = true
      }
      return returnValue
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Informes/Tratamientos/ShpContTratamientos.vue